import { Authority } from '@/shared/security/authority';

const JhiUserManagementComponent = () => import('@/admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('@/admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('@/admin/user-management/user-management-edit.vue');
const JhiConfigurationComponent = () => import('@/admin/configuration/configuration.vue');
const JhiDocsComponent = () => import('@/admin/docs/docs.vue');
const JhiHealthComponent = () => import('@/admin/health/health.vue');
const JhiLogsComponent = () => import('@/admin/logs/logs.vue');
const JhiAuditsComponent = () => import('@/admin/audits/audits.vue');
const JhiMetricsComponent = () => import('@/admin/metrics/metrics.vue');
const InviteNioAdminComponent = () => import('@/admin/invite-nio-admin/invite-nio-admin.vue');
const InviteCompanyOrgAdminComponent = () => import('@/admin/invite-company-org-admin/invite-company-org-admin.vue');
const InviteNioOrgAdminComponent = () => import('@/admin/invite-nio-org-admin/invite-nio-org-admin.vue');
const InviteNioOrgAdminForNioComponent = () => import('@/admin/invite-nio-org-admin-for-nio/invite-nio-org-admin-for-nio.vue');

export default [
  {
    path: '/admin/user-management',
    name: 'JhiUser',
    component: JhiUserManagementComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/new',
    name: 'JhiUserCreate',
    component: JhiUserManagementEditComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/edit',
    name: 'JhiUserEdit',
    component: JhiUserManagementEditComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/user-management/:userId/view',
    name: 'JhiUserView',
    component: JhiUserManagementViewComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },

  {
    path: '/admin/docs',
    name: 'JhiDocsComponent',
    component: JhiDocsComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/audits',
    name: 'JhiAuditsComponent',
    component: JhiAuditsComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/jhi-health',
    name: 'JhiHealthComponent',
    component: JhiHealthComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/logs',
    name: 'JhiLogsComponent',
    component: JhiLogsComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/jhi-metrics',
    name: 'JhiMetricsComponent',
    component: JhiMetricsComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/jhi-configuration',
    name: 'JhiConfigurationComponent',
    component: JhiConfigurationComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/invite-nio-admin',
    name: 'InviteNioAdmin',
    component: InviteNioAdminComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.NIO_SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/invite-company-org-admin',
    name: 'InviteCompanyOrgAdmin',
    component: InviteCompanyOrgAdminComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.COMPANY_SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/invite-nio-org-admin',
    name: 'InviteNioOrgAdmin',
    component: InviteNioOrgAdminComponent,
    meta: { authorities: [Authority.SUPER_ADMIN, Authority.NIO_SUPER_ADMIN, Authority.ADMIN] },
  },
  {
    path: '/admin/invite-nio-org-admin-for-nio',
    name: 'InviteNioOrgAdminForNio',
    component: InviteNioOrgAdminForNioComponent,
    meta: { authorities: [Authority.NIO_ADMIN, Authority.SUPER_ADMIN, Authority.NIO_SUPER_ADMIN] },
  },
];
